/** @jsxImportSource @emotion/react */
import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import NotificationContext from 'contexts/notificationContext';

import Header from './Header/Header';
import Footer from './Footer/Footer';
import { childrenContainerStyles, notificationContainerStyles } from './Layout.styles';

const Layout = ({ isHeaderShown = true, children }) => {
  const { notification, setNotification, notificationContent } = useContext(NotificationContext);

  useEffect(() => {
    if (notification) {
      setTimeout(() => setNotification(false), 3500);
    }
  }, [notification, setNotification]);

  return (
    <div>
      {isHeaderShown && <Header />}
      {
        notification && (
          <div css={notificationContainerStyles(notificationContent.type)}>
            {notificationContent.message}
          </div>
        )
      }
      <div css={childrenContainerStyles}>
        {children}
      </div>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  isHeaderShown: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Layout;
